import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router';
import ShopMainLayout from './app/components/ShopMainLayout';
import Barbers from './app/barbers/Barbers';
import Services from './app/dynamicBooking/barber/Services';
import MakeReservation from './app/reservation/MakeReservation';
import { generateUrlString } from './app/utils/helpers';


const barberUrl = generateUrlString({ shopRoute: '' });
const serviceUrl = generateUrlString({ shopRoute: '', barberRoute: '' });
const pickTimeUrl = generateUrlString({ shopRoute: '', barberRoute: '', serviceId: '' });

const makeReservationUrl = generateUrlString({
  shopRoute: '',
  barberRoute: '',
  serviceId: '',
  reservationTime: '',
});

const redirectFromOldUrl = (nextState, replace, callback) => {
  if (nextState.params.shopRoute.length === 2) {
    replace({
      pathname: `/${nextState.params.barberRoute}/${nextState.params.serviceId ? nextState.params.serviceId : ''}`,
    });
  }
  callback();
};

export default () => (
  <Route component={ShopMainLayout}>
    <Route path={barberUrl} component={Barbers} />
    <Route
      path={serviceUrl}
      component={Services}
      onEnter={redirectFromOldUrl}
      ignoreScrollBehavior
    />
    <Route
      path={pickTimeUrl}
      component={Services}
      onEnter={redirectFromOldUrl}
      ignoreScrollBehavior
    />
    <Route
      path={makeReservationUrl}
      component={MakeReservation}
      onEnter={redirectFromOldUrl}
    />
    <Redirect
      from={`${makeReservationUrl}/**`}
      to={makeReservationUrl}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./src/OldRoutes.jsx